module.exports = __webpack_public_path__ + "static/media/FD.59203d84.png";